/* eslint-disable react-refresh/only-export-components */
import {
  Portal,
  Spinner,
  Stack,
  Toast,
  Toaster as ChakraToaster,
  createToaster,
} from "@chakra-ui/react"

export const toaster = createToaster({
  placement: "bottom-end",
  pauseOnPageIdle: true,
})

export const Toaster = () => {
  return (
    <Portal>
      <ChakraToaster toaster={toaster} insetInline={{ mdDown: "4" }}>
        {(toast) => (
          <Toast.Root 
            width={{ md: "sm" }}
            bg="rgba(18, 14, 28, 0.99)"
            borderColor="whiteAlpha.200"
            borderWidth="1px"
            borderRadius="2xl"
            boxShadow="-10px 15px 40px rgba(0, 0, 0, 0.8), inset 0 1px 1px rgba(255,255,255,0.1)"
            p={4.5}
            color="white"
            display="flex"
            gap={3.5}
            alignItems="center"
            zIndex={9999}
          >
            {toast.type === "loading" ? (
              <Spinner size="sm" color="yellow.300" />
            ) : (
              <Toast.Indicator color="yellow.300" />
            )}
            <Stack gap="1" flex="1" maxWidth="100%">
              {toast.title && <Toast.Title fontSize="sm" fontWeight="bold" color="white">{toast.title}</Toast.Title>}
              {toast.description && (
                <Toast.Description fontSize="xs" color="whiteAlpha.700">{toast.description}</Toast.Description>
              )}
            </Stack>
            {toast.action && (
              <Toast.ActionTrigger color="yellow.350">{toast.action.label}</Toast.ActionTrigger>
            )}
            {toast.closable && <Toast.CloseTrigger color="whiteAlpha.600" _hover={{ color: "red.400" }} />}
          </Toast.Root>
        )}
      </ChakraToaster>
    </Portal>
  )
}
